<template lang="html">
  <md-sidenav
    class="md-left md-fixed"
    ref="leftSidenav"
    id="leftSidenav"
    md-swipeable>
    <md-toolbar class="md-transparent">
    </md-toolbar>
    <md-layout style="height:40px;" md-hide-medium-and-up></md-layout>
    <md-layout md-column>
      <div class="container">
        <md-list ref="menu" id="menu_sbmenu">
          <!-- <md-list-item v-for="(menu, index) in menuList"
          key="index" v-if="menu.subdepartamentos.length" >
            <span><a class="depto">{{menu.descripcion}}</a></span>

            <md-list-expand>
              <md-list>
                <md-list-item class="md-inset" 
                  key="indx" @click.native="filterByDepto(menu.idinterno)">
                    <a class="depto">{{menu.descripcion}}</a></md-list-item>
                <md-list-item class="md-inset" 
                  v-for="(sbmenu, indx) in menu.subdepartamentos" 
                  key="indx" @click.native="filterBySubDepto(sbmenu.idinterno)">
                    <a class="subdepto">{{sbmenu.descripcion}}</a></md-list-item>
              </md-list>
            </md-list-expand>
          </md-list-item>

        </md-list>
        <md-list ref="menu" id="menu">
          <md-list-item v-for="(menu, index) in menuList"
            key="index" v-if="!menu.subdepartamentos.length" @click.native="filterByDepto(menu.idinterno)">
            <span><a class="depto">{{menu.descripcion}}</a></span>

          </md-list-item> -->
          
          <md-list-item @click.native="goTo('inicial')">
            <span><a class="depto">Catalogo</a></span>
          </md-list-item>

          <md-list-item @click.native="goTo('pedido')">
            <span><a class="depto">Mis Pedidos STShop</a></span>
          </md-list-item>

          <md-list-item @click.native="goTo('factura')">
            <span><a class="depto">Mis Documentos</a></span>
          </md-list-item>
          
          <md-list-item @click.native="goTo('perfil')">
            <span><a class="depto">Mi Informacion</a></span>
          </md-list-item>

        </md-list>
      </div>
    </md-layout>
    <md-layout class="footer" md-column >
      <md-layout md-align="start" class="powered">Powered by:</md-layout>
      <md-layout md-align="center" style="padding:10px">
        <img id="logo-stshop" src="../../assets/img/Compart-blue.png" alt="" />
      </md-layout>
      <md-layout md-align="center">
        <a href="https://www.superticket.mx" target="_blank">www.superticket.mx</a>
      </md-layout>

    </md-layout>
  </md-sidenav>
</template>

<script type="text/javascript">
  export default {
    props: {
      menuList: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    methods: {
      lockBodyScroll() {
        document.body.style.overflowY = 'hidden';
      },
      filterByDepto(id) {
        this.$router.replace({ name: 'inicial', params: { idDepartamento: id }});
      },
      goTo(page) {
        this.$router.replace({ name: page });
        this.toggle()
      },
      filterBySubDepto(id) {
        this.$router.replace({ name: 'inicial', params: { idSubDepartamento: id }});
      },
      toggle() {
        this.$refs.leftSidenav.toggle();
      },
      toggleLockBodyScroll() {
        const scroll = document.body.style.overflowY === 'hidden' ?
          'auto' :
          'hidden';
        document.body.style.overflowY = scroll;
      },
      unlockBodyScroll() {
        document.body.style.overflowY = 'auto';
      },
    },
  };
</script>

<style src="./Sidebar.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/shared-components/sidebar/Sidebar.vue